<template>
  <div class="rm-screen">
    <div v-if="busy" class="rm-empty">
      <v-progress-circular indeterminate color="#c2410c"></v-progress-circular>
    </div>
    <div v-else-if="!rows.length" class="rm-empty">
      <v-icon v-if="!searchText" size="40" color="#8a817a">mdi-package-variant-closed</v-icon>
      {{ emptyTitle }}
    </div>

    <template v-else>
      <div class="rm-stats">
        <div v-for="(stat, index) in kpis" :key="stat.key" class="rm-stat" :class="{ 'rm-stat--inverse': index === 0 }">
          <span class="rm-stat__label">{{ stat.label }}</span>
          <span class="rm-stat__value rm-num">{{ stat.value }}</span>
        </div>
      </div>

      <ul class="rm-list rm-card">
        <li v-for="row in shownRows" :key="row.key" class="gm-user">
          <button type="button" class="gm-user__btn" @click="openOrder(row)">
            <span class="gm-user__text">
              <span class="gm-user__name">{{ row.worker }}</span>
              <span class="gm-user__meta">{{ [hasBranches ? row.branch : "", row.restaurant].filter(Boolean).join(" · ") }}</span>
              <span class="cmm-meals">
                <span v-for="(meal, index) in row.meals" :key="index" class="cmm-meals__item">
                  <b class="rm-num">{{ meal.quantity }}×</b>
                  <span class="cmm-meals__name">{{ meal.name }}</span>
                  <report-shift-tag v-if="meal.shiftNumber" :shift="meal.shiftNumber"></report-shift-tag>
                </span>
              </span>
            </span>
            <v-icon size="18" color="#8a817a">mdi-chevron-right</v-icon>
          </button>
        </li>
      </ul>
      <button v-if="hiddenCount > 0" type="button" class="rm-text-btn gm-user__more" @click="expanded = true">
        {{ $t("report_mobile.show_all_n", { n: rows.length }) }}
      </button>
    </template>

    <ui-sheet v-model="orderSheet" :ready="Boolean(selected)" :label="selected ? selected.worker : ''">
      <template #default>
        <h2 class="cmm-sheet__title">{{ selected.worker }}</h2>
        <dl class="cmm-facts">
          <div>
            <dt>{{ $t("makeOrder") }}</dt>
            <dd class="rm-num">#{{ selected.order.id }}</dd>
          </div>
          <div v-if="hasBranches && selected.branch">
            <dt>{{ $t("branch") }}</dt>
            <dd>{{ selected.branch }}</dd>
          </div>
          <div>
            <dt>{{ $t("restaurant") }}</dt>
            <dd>{{ selected.restaurant }}</dd>
          </div>
          <div v-if="selected.location">
            <dt>{{ $t("delivery_location") }}</dt>
            <dd>{{ selected.location }}</dd>
          </div>
        </dl>
        <ul class="rm-list cmm-order-meals">
          <li v-for="(meal, index) in selected.order.meals" :key="index" class="cmm-order-meals__row">
            <span class="cmm-order-meals__name">
              <b class="rm-num">{{ meal.quantity }}×</b> {{ toLatin(meal.name) }}
            </span>
            <report-shift-tag v-if="shiftOf(meal)" :shift="shiftOf(meal)"></report-shift-tag>
            <span class="rm-num cmm-order-meals__price">{{ mealPrice(meal) }}</span>
          </li>
        </ul>
        <p v-if="selected.order.delivery_notes" class="rm-muted">{{ selected.order.delivery_notes }}</p>
      </template>
    </ui-sheet>
  </div>
</template>

<script>
import CompanyDesktopMultiPackages from "@/components/company-report/desktop/screens/multi/CompanyDesktopMultiPackages.vue";
import ReportShiftTag from "@/components/report/shared/ReportShiftTag.vue";
import "@/components/report/mobile/screens/group/groupMobileUsers.scss";
import hasMultiMobile from "../../hasMultiMobile";

const PAGE_SIZE = 20;

/**
 * Mobilni "Pakovanje" firme "više restorana": narudžbe radnika po restoranu sa obrocima i smenom. Dodir na narudžbu
 * otvara detalje (obroci sa cenom). Restorani, smene, period i pretraga (radnik, restoran ili obrok) su u
 * zaglavlju. Računa kao ekran za računar.
 */
export default {
  name: "CompanyMobileMultiPackages",
  extends: CompanyDesktopMultiPackages,
  mixins: [hasMultiMobile],
  components: { ReportShiftTag },
  data: () => ({
    expanded: false,
    orderSheet: false,
    selected: null,
  }),
  computed: {
    shownRows() {
      return this.expanded || this.searchText ? this.rows : this.rows.slice(0, PAGE_SIZE);
    },
    hiddenCount() {
      return this.rows.length - this.shownRows.length;
    },
  },
  methods: {
    /** Detalji narudžbe u listu sa dna (na računaru su u panelu). */
    openOrder(row) {
      this.selected = row;
      this.orderSheet = true;
    },
    shiftOf(meal) {
      const match = String(meal.shift || "").match(/(\d+)/);
      return match ? Number(match[1]) : null;
    },
    mealPrice(meal) {
      return `${this.money(meal.price)} ${meal.currency || "KM"}`;
    },
  },
};
</script>
